import { formatWtfNl, parseWtfNl } from './formatWtf';

const SHIFT_ORDER = {
    ochtend: 0,
    middag: 1,
};

const shiftSortKey = (shiftLabel) => {
    const key = String(shiftLabel ?? '')
        .trim()
        .toLowerCase();
    return SHIFT_ORDER[key] ?? 50;
};

/**
 * Display-only: one row per calendar date with summed WTF / dag.
 * Keeps underlying shift rows for edit/delete.
 *
 * @param {Array<object>} rows
 * @returns {Array<object>}
 */
export const aggregateDagdelenByDate = (rows = []) => {
    const byDate = new Map();

    rows.forEach((row) => {
        const dateKey = row.datum || `id-${row.id}`;
        if (!byDate.has(dateKey)) {
            byDate.set(dateKey, {
                dateKey,
                datum: row.datum || '',
                dag: row.dag || '',
                shifts: [],
            });
        }
        const group = byDate.get(dateKey);
        if (!group.dag && row.dag) {
            group.dag = row.dag;
        }
        group.shifts.push({
            id: row.id,
            dagdeel: row.dagdeel || row.shift || '',
            wtf: row.wtf ?? 0,
            soortWtf: row.soortWtf,
            dagType: row.dagType,
            contractType: row.contractType,
        });
    });

    return Array.from(byDate.values()).map((group) => {
        const shifts = [...group.shifts].sort(
            (a, b) => shiftSortKey(a.dagdeel) - shiftSortKey(b.dagdeel),
        );
        const sum = shifts.reduce((total, shift) => total + parseWtfNl(shift.wtf), 0);

        return {
            id: shifts[0]?.id ?? group.dateKey,
            dateKey: group.dateKey,
            datum: group.datum,
            dag: group.dag,
            wtfPerDag: formatWtfNl(sum),
            shifts,
        };
    });
};
